import Vue from 'vue'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VueTouch from 'vue-touch'

import App from './App.vue'
import router from './router'
import store from './store'
import api from './lib/api'
import logger from './lib/logger'
import storage from './lib/storage'
import config from './lib/config'
import util from './lib/util'
import './assets/css/my-mint.scss' // 用于自定义mint-UI

import VueImageSwipe from 'vue-image-swipe'
import 'vue-image-swipe/dist/vue-image-swipe.css'

Vue.use(VueImageSwipe)

Vue.use(Mint)
Vue.use(VueAwesomeSwiper)
Vue.use(VueTouch, { name: 'v-touch' })

Vue.config.productionTip = false

Vue.prototype.$faApi = api
Vue.prototype.$faLogger = logger
Vue.prototype.$faStorage = storage
Vue.prototype.$faConfig = config
Vue.prototype.$faUtil = util

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
